import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';

type Unit = 't/ha' | 'uN' | 'kg/m²';

interface MetricInput {
  name: string;
  unit: Unit;
  n1: number;
  n: number;
}
interface TripletInput {
  metrics: MetricInput[];
}

@Component({
  standalone: true,
  selector: 'app-grouped-bar-chart',
  templateUrl: './grouped-bar-chart.component.html',
  styleUrls: ['./grouped-bar-chart.component.scss'],
  imports: [CommonModule, NgChartsModule],
})
export class GroupedBarChartComponent implements OnChanges {
  @Input() groupedBarData: TripletInput = { metrics: [] };

  metrics: Array<{
    title: string;
    chart: {
      labels: string[];
      datasets: {
        label: string;
        data: number[];
        backgroundColor: string;
        maxBarThickness?: number;
      }[];
      options: any;
    };
  }> = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['groupedBarData']) this.rebuild();
  }

  private rebuild(): void {
    const src = (this.groupedBarData && this.groupedBarData.metrics) || [];
    const items = src.filter(function (m) {
      return m && (m.n1 != null || m.n != null);
    });

    this.metrics = items.map((m) => {
      const unit = m.unit;
      const title = m.name + ' (' + unit + ')';
      const labels = [''];
      const datasets = [
        {
          label: 'N-1',
          data: [m.n1 || 0],
          backgroundColor: '#B0C4DE',
          maxBarThickness: 60,
        },
        {
          label: 'N',
          data: [m.n || 0],
          backgroundColor: '#2C3E50',
          maxBarThickness: 60,
        },
      ];

      const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { top: 6, right: 6, bottom: 6, left: 6 } },
        animation: false,
        plugins: {
          legend: { position: 'top' },
          tooltip: {
            callbacks: {
              label: (ctx: any) => {
                const v = ctx.dataset.data[ctx.dataIndex] || 0;
                return ctx.dataset.label + ': ' + v + ' ' + unit;
              },
            },
          },
        },
        scales: {
          x: {
            type: 'category',
            offset: true,
            grid: { display: false },
            ticks: { maxRotation: 0, autoSkip: false },
          },
          y: {
            beginAtZero: true,
            grid: { color: 'rgba(0,0,0,0.10)' },
            ticks: { maxTicksLimit: 5 },
          },
        },
      };

      return { title: title, chart: { labels: labels, datasets: datasets, options: options } };
    });
  }
}
